import React from "react";
import createReactClass from "create-react-class";

import PhotoDeletebutton from "./photo_delete_button";
import PhotoFaceMaskbutton from "./photo_face_mask_button";

export default createReactClass({
  displayName: "Root",
  getPhotoDirection() {
    var direction = this.props.photo.is_wide ? "photo-w" : "photo-h";
    return direction;
  },
  handlePhotoItem() {
    this.props.openModal(this.props.index);
  },
  // キーボード（Enter / スペース）でも写真を開けるようにする
  handlePhotoItemKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.handlePhotoItem();
    }
  },
  getInitialState() {
    return {
      display: "none",
      direction: "photo-w",
    };
  },
  componentDidMount() {
    this.setState({
      direction: this.getPhotoDirection(this.props.photo.safe_image),
    });
  },
  render() {
    return (
      // 2026: 正方形のタイル。隙間なく細い線で区切って敷きつめる
      <li className="alb-photo" data-cat="1">
        <a className="alb-photo__wrap">
          <PhotoDeletebutton
            photoId={this.props.photo.id}
            isActive={this.props.isPhotoDeletebuttonActive}
            deletePhotoSelected={this.props.deletePhotoSelected}
          />
          <PhotoFaceMaskbutton
            photoId={this.props.photo.id}
            isActive={this.props.isFaceMaskButtonActive}
            faceMaskPhotoSelected={this.props.faceMaskPhotoSelected}
            index={this.props.index}
          />
          <span
            className="alb-photo__open"
            onClick={this.handlePhotoItem}
            onKeyDown={this.handlePhotoItemKeyDown}
            role="button"
            tabIndex={0}
            aria-label={"写真を開く（" + (this.props.index + 1) + "枚目）"}
          >
            <img
              className="alb-photo__img"
              src={this.props.photo.safe_image}
              alt=""
              loading="lazy"
            />
          </span>
        </a>
      </li>
    );
  },
});
